<template>
  <div id="paginaPraticheVVF">
    <!-- Elementi Pagina----------------------------------------------------------------------------------- -->
    <b-row class="match-height">
      <!-- Card Grid View: GridElencoPraticheVVF -->
      <b-col xl="12" md="12">
        <b-card tag="article" class="mb-2">
          <b-card-header class="align-items-baseline">
            <div>
              <b-card-title>Elenco Pratiche SIAE</b-card-title>
              <b-card-text class="mb-0"> Teatro Coccia </b-card-text>
            </div>
          </b-card-header>
          <b-card-body class="mb-0">
            <!-- card body -->
            <b-row>
              <b-col xl="12" md="12" class="pt-1">
                <ejs-dropdownlist id="dropStagione" ref="dropStagione" :query="queryAnno"
                  :dataSource="stagioniList" :index="annoIndex" :fields="stagioniFields"
                  :change="onStagioneChange" v-model="stagioneCorrente"
                  placeholder="Seleziona una stagione"></ejs-dropdownlist>
              </b-col>
              <!-- Timer Alert -->
              <b-col xl="6" md="12">
                <b-alert :show="alertADismissCountDown" dismissible variant="warning"
                  @dismissed="alertADismissCountDown = 0" @dismiss-count-down="alertACountDownChanged">
                  <p>Occorre selezionare una riga della tabella</p>
                  <b-alert variant="warning" :max="alertADismissSecs" :value="alertADismissCountDown" height="4px" />
                </b-alert>
              </b-col>

              <b-col xl="12" md="12" class="pt-1">
                <ejs-grid id="gridA" ref="gridA" :dataSource="praticheSIAEFullData" :allowSorting="true"
                  :sortSettings="gridA.sortOptions" :toolbarClick="gridAClickHandler" :toolbar="gridA.toolbarOptions"
                  :height="gridA.height" :allowFiltering="true" :filterSettings="gridA.filterOptions"
                  :editSettings="gridA.editOptions" :actionBegin="gridAactionBegin" :actionComplete="gridAactionComplete">
                  <e-columns>
                    <e-column field="id" headerText="ID" :isPrimaryKey="true" width="60"></e-column>
                    <e-column field="spettacolo" headerText="Spettacolo" width="100"></e-column>
                    <e-column field="tipologia" headerText="Tipologia" width="60"></e-column>
                    <e-column field="dataCreazione" headerText="Data Creazione" width="60" :format="settings.formatoData"
                      type="date"></e-column>
                    <e-column field="reciteStringa" headerText="Recite" width="150"></e-column>
                  </e-columns>
                </ejs-grid>
              </b-col>
            </b-row>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>

    <!-- dialogA: dialogDettaglioPraticaSIAE ---------------------------------------------------------------------------------------------------- -->
    <ejs-dialog id="dialogA" ref="dialogA" :header="dialogA.header" :buttons="dialogA.buttons" :visible="dialogA.visible"
      :showCloseIcon="dialogA.showCloseIcon" :close="dialogAClose" :open="dialogAOpen" :zIndex="dialogA.zIndex"
      :animationSettings="dialogA.animationSettings" :isModal="dialogA.isModal">
      <!-- Content dialog -->
      <b-tabs ref="tabAdialogA" v-model="dialogA.tabAdialogAIndex">
        <b-tab title="Dati Pratica SIAE">
          <b-row class="match-height">
            <!-- Card con Elementi Input: dati pratica SIAE -->
            <b-col xl="12" md="12">
              <b-card tag="article" class="mb-2">
                <b-card-header class="align-items-baseline">
                  <div>
                    <b-card-title>Dati Pratica SIAE</b-card-title>
                    <b-card-text class="mb-0" />
                  </div>
                </b-card-header>
                <b-card-body class="mb-0">
                  <!-- card body -->
                  <b-row>
                    <b-col xl="12" md="12" class="mb-2">
                      <label for="id" class="h5">Id</label>
                      <ejs-textbox id="id" v-model="praticheSIAEActiveData.id" floatLabelType="Never" cssClass=""
                        placeholder="id" showClearButton="true" type="text" autocomplete="false" :readonly="true" />
                    </b-col>

                    <b-col xl="12" md="12" class="mb-2">
                      <label for="dataCreazione" class="h5">Data di Creazione</label>
                      <ejs-datepicker id="dataCreazione" v-model="praticheSIAEActiveData.dataCreazione"
                        :format="settings.formatoDatepicker" placeholder="Data di Creazione"
                        :firstDayOfWeek="settings.firstDayOfWeek"/>
                    </b-col>

                    <!-- Input di tipo MULTISELECT: praticheSIAEActiveData.reciteAssociate                      DA INSERIRE-->

                    <b-col xl="12" md="12" class="mb-2">
                      <label for="stagione" class="h5">Stagione</label>
                      <ejs-dropdownlist id="stagione" ref="stagione" v-model="praticheSIAEActiveData.stagione"
                        :dataSource="stagioniList" :fields="stagioniFields" :allowFiltering="true"
                        :change="onStagioneNewChange" />
                    </b-col>

                    <b-col xl="12" md="12" class="mb-2">
                      <label for="spettacolo" class="h5">Spettacolo</label>
                      <ejs-dropdownlist
                        id="spettacolo" ref="spettacolo"
                        v-model="spettacoloCorrente"
                        :query="querySpettacoli" :allowFiltering="true" :filtering='spettacoloFiltering'
                        :dataSource="elencoSpettacoliList" :fields="elencoSpettacoliFields"
                        placeholder="Selezione Spettacolo"
                        :change="onSpettacoloChange"
                      />
                    </b-col>

                    <b-col xl="12" md="12" class="pt-1">
                      <ejs-grid id="gridD" ref="gridD" :dataSource="reciteSpettacoloFullData" :allowSorting="true"
                        :toolbar="gridD.toolbarOptions" :height="gridD.height" :sortSettings="gridD.sortOptions"
                        :allowFiltering="true" :filterSettings="gridD.filterOptions" :editSettings="gridD.editOptions"
                       >
                        <e-columns>
                          <e-column field="id" headerText="ID" :isPrimaryKey="true" width="30"></e-column>
                          <e-column field="data" headerText="Data" :format="settings.formatoData" type="date"
                            width="100"></e-column>
                          <e-column field="orario" headerText="Orario" width="150"></e-column>
                        </e-columns>
                      </ejs-grid>
                    </b-col>
                  </b-row>
                </b-card-body>
              </b-card>
            </b-col>
          </b-row>
        </b-tab>
      </b-tabs>
    </ejs-dialog>

  </div>
</template>

<script>
import Vue from "vue";
import useJwt from "@/auth/jwt/useJwt";
// import bootstrap-Vue
import {
  LayoutPlugin,
  TabsPlugin,
  CardPlugin,
  DropdownPlugin,
  ImagePlugin,
  LinkPlugin,
  AlertPlugin,
  ToastPlugin,
} from "bootstrap-vue";
// import Vuexy

// import Syncfusion
import { enableRipple } from "@syncfusion/ej2-base";
import { Query } from "@syncfusion/ej2-data";
import {
  DateTimePickerPlugin,
  DateRangePickerPlugin,
  DatePickerPlugin,
  TimePickerPlugin,
} from "@syncfusion/ej2-vue-calendars";
import {
  ButtonPlugin,
  CheckBoxPlugin,
  SwitchPlugin,
} from "@syncfusion/ej2-vue-buttons";
import {
  TextBoxPlugin,
  NumericTextBoxPlugin,
  MaskedTextBoxPlugin,
  UploaderPlugin,
} from "@syncfusion/ej2-vue-inputs";
import {
  DropDownListPlugin,
  MultiSelectPlugin,
  CheckBoxSelection,
} from "@syncfusion/ej2-vue-dropdowns";
import { DialogPlugin } from "@syncfusion/ej2-vue-popups";
import {
  GridPlugin,
  ForeignKey,
  Edit as GridEdit,
  Toolbar as GridToolbar,
  Sort as GridSort,
  Filter as GridFilter,
} from "@syncfusion/ej2-vue-grids";
import { DropDownButtonPlugin } from "@syncfusion/ej2-vue-splitbuttons";

const axios = require("axios");
// use bootstrap-vue
Vue.use(TabsPlugin);
Vue.use(CardPlugin);
Vue.use(LayoutPlugin);
Vue.use(DropdownPlugin);
Vue.use(ImagePlugin);
Vue.use(LinkPlugin);
Vue.use(AlertPlugin);
Vue.use(ToastPlugin);
// use Syncfusion
Vue.use(TextBoxPlugin);
Vue.use(NumericTextBoxPlugin);
Vue.use(MaskedTextBoxPlugin);
Vue.use(UploaderPlugin);
Vue.use(DateRangePickerPlugin);
Vue.use(DatePickerPlugin);
Vue.use(DateTimePickerPlugin);
Vue.use(TimePickerPlugin);
Vue.use(DropDownListPlugin);
Vue.use(MultiSelectPlugin);
Vue.use(ButtonPlugin);
Vue.use(CheckBoxPlugin);
Vue.use(SwitchPlugin);
Vue.use(DialogPlugin);
Vue.use(GridPlugin);
Vue.use(DropDownButtonPlugin);
enableRipple(true);
// api
const apiPraticheSIAEUrl = "/demo/api/praticasiae";
const apiPraticheSIAERicercaUrl = "/demo/api/praticasiae/ricerca";
const apiPraticheSIAEReciteUrl = "/demo/api/praticasiae/ricerca_recite";
const apiReciteRicercaSIAEAnnoUrl = "/demo/api/recita/ricerca_siae";
const apiReciteRicercaSpettacoloSIAEUrl = "/demo/api/recita/ricerca_spettacolo_siae";
const apiSpettacoloUrl = "/demo/api/spettacolo/ricerca";

export default Vue.extend({
  components: {},
  data() {
    return {
      dataOggi: null,
      // tmp
      nonMostrare: false, // utile per non cancellare codice in editing
      // generali
      settings: {
        formatoData: { type: "date", format: "dd-MM-yyyy" }, // da usare per grid
        formatoOra: { skeleton: "Hm" },
        //formatoOra: 'HH:mm',
        formatoOraGrid: { type: "dateTime", format: "HH:mm" }, // da usare per grid
        formatoDatepicker: "dd-MM-yyyy", // da usare per i datepicker
        intervalloOra: 5,
        firstDayOfWeek: 1,
      },
      // praticheSIAE
      praticheSIAEFullData: [], // elenco completo dati spettacoli
      praticheSIAEActiveId: 0, // Id spettacolo attivo (0 se nuovo)
      praticheSIAEActiveData: {}, // dati completi dell spettacolo attivo
      praticheSIAESavedData: {}, // dati completi dell spettacolo attivo
      praticheSIAEDefaultData: {}, // dati completi di default per nuovi spettacoli
      // per inizializzazione dropdown a null
      initIndex: -1,
      // per gestione stagioni
      stagioniList: [
        { label: "Anno 2022", val: "2022" },
        { label: "Anno 2023", val: "2023" },
        { label: "Anno 2024", val: "2024" },
        { label: "Anno 2025", val: "2025" },
        { label: "Anno 2026", val: "2026" },
      ],
      stagioniFields: { value: "val", text: "label" },
      elencoSpettacoliList: [],
      elencoSpettacoliFields: { value: "id", text: "titolo" },
      annoIndex: -1,
      queryAnno: null,
      querySpettacoli: null,
      stagioneCorrente: null,
      spettacoloCorrente: null,
      booleanList: [
        { label: "Si", val: true },
        { label: "No", val: false },
      ],
      // per gestione meseRiferimento
      meseRiferimentoList: [
        { label: "Gennaio", val: "01" },
        { label: "Febbraio", val: "02" },
        { label: "Marzo", val: "03" },
        { label: "Aprile", val: "04" },
        { label: "Maggio", val: "05" },
        { label: "Giugno", val: "06" },
        { label: "Luglio", val: "07" },
        { label: "Agosto", val: "08" },
        { label: "Settembre", val: "09" },
        { label: "Ottobre", val: "10" },
        { label: "Novembre", val: "11" },
        { label: "Dicembre", val: "12" },
      ],
      meseRiferimentoFields: { value: "val", text: "label" },
      // lista valori tipologia pratica
      praticheSIAETipoList: [
        { label: "Ordinaria", val: "ordinaria" },
        { label: "Aggiuntiva", val: "aggiuntiva" },
      ],
      praticheSIAETipoFields: { text: "label", value: "val" },
      // lista valori stato pratica
      praticheSIAEStatoList: [
        { label: "Da Generare", val: "dagenerare" },
        { label: "Generato", val: "generato" },
        { label: "Pagato", val: "pagato" },
      ],
      praticheSIAEStatoFields: { text: "label", value: "val" },

      // reciteSpettacolo
      reciteSpettacoloFullData: [], // elenco completo delle recite associate ad uno spettacolo
      reciteSpettacoloActiveId: 0, // Id recita attiva (0 se nuovo)
      reciteSpettacoloActiveData: {}, // dati completi della recita attualmente visualizzata
      reciteSpettacoloDefaultData: {},
      // lista valori tipologia recita
      reciteTipologiaList: [
        { label: "Rappresentazione", val: "rappresentazione" },
        { label: "Prova Generale", val: "provaGenerale" },
      ],
      reciteTipologiaFields: { text: "label", value: "val" },
      // lista valori stato recita
      reciteStatoList: [
        { label: "Confermata", val: "confermata" },
        { label: "Annullata", val: "annullata" },
      ],
      reciteStatoFields: { text: "label", value: "val" },
      // lista valori VigiliFuoco recita
      reciteVigiliFuocoList: [
        { label: "Non Necessari", val: "nonNecessari" },
        { label: "Comunicazione Effettuata", val: "comunicazioneEffettuata" },
        {
          label: "Comunicazione non Effettuata",
          val: "comunicazioneNonEffettuata",
        },
      ],
      reciteVigiliFuocoFields: { text: "label", value: "val" },
      // lista valori Siae recita
      reciteSiaeList: [
        { label: "Non Necessaria", val: "nonNecessari" },
        { label: "Comunicazione Effettuata", val: "comunicazioneEffettuata" },
        {
          label: "Comunicazione non Effettuata",
          val: "comunicazioneNonEffettuata",
        },
      ],
      reciteSiaeFields: { text: "label", value: "val" },

      // per alertA
      alertADismissSecs: 3,
      alertADismissCountDown: 0,

      // per dialogA
      dialogA: {
        header: "",
        visible: false,
        showCloseIcon: true,
        buttons: [
          {
            click: this.dialogAOk,
            buttonModel: { content: "OK", isPrimary: true },
          },
          { click: this.dialogACancel, buttonModel: { content: "Cancel" } },
        ],
        animationSettings: { effect: "FadeZoom", duration: 400, delay: 0 }, // { effect: 'None' }, // selezionata per primo livello
        zIndex: 1050,
        tabAdialogAIndex: 0,
        isModal: false,
      },
      // per gridA
      gridA: {
        height: 300,
        editOptions: {
          allowEditing: false,
          allowDeleting: true,
        },
        filterOptions: { type: "Excel" },
        toolbarOptions: [
          {
            text: "Nuova Pratica SIAE",
            tooltipText: "Inserisci nuova Pratica SIAE",
            prefixIcon: "e-plus",
            id: "new",
          },
          /*{
            text: "Modifica Pratica SIAE",
            tooltipText: "Modifica Pratica SIAE",
            prefixIcon: "e-expand",
            id: "edit",
          },*/
          {
            text: "Cancella Pratica SIAE",
            tooltipText: "Cancella Pratica SIAE",
            prefixIcon: "e-cancel",
            id: "delete",
          },
          {
            text: "Download Pratica",
            tooltipText: "Download Pratica",
            prefixIcon: "e-save",
            id: "download",
          },
          "Search",
        ],
        sortOptions: { columns: [{ field: "dataCreazione", direction: "Ascending" }] },
      },
      // per gridD
      gridDFlag: false,
      gridD: {
        height: 300,
        editOptions: {
          allowEditing: false,
          allowDeleting: true,
        },
        filterOptions: { type: "Excel" },
        toolbarOptions: [
          "Search",
        ],
        sortOptions: { columns: [{ field: "data", direction: "Ascending" }] },
      }, //


    };
  },
  created() {
    console.log("Pagina PraticheSIAE Creata");
    this.dataOggi = new Date()
    this.stagioneCorrente = this.dataOggi.getFullYear().toString()
    // inizializzazione elenchi dal backend
    // chiamate API

    // recupero elenco PraticheSIAE dal backend
    if (localStorage.getItem("userData") !== null) {

      console.log("Recupero elenco PraticheSIAE dal backend");
      const datiDaInviare = {
        stagione: this.stagioneCorrente,
      };
      useJwt.post(apiPraticheSIAERicercaUrl, datiDaInviare).then((d) => {
        //console.log("PraticheSIAE");
        console.log(d.data);
        this.praticheSIAEFullData = d.data;
        this.praticheSIAEFullData.forEach((obj) => {
          let reciteStr = ""
          if (obj.recite != null) {
            obj.spettacolo = obj.recite[0].spettacoloName
            obj.recite.forEach((r) => {
              const dataRecita = new Date(r.data)
              const dataStringa = dataRecita.toLocaleDateString("it-IT", {
                weekday: "long",
                year: "numeric",
                month: "long",
                day: "2-digit",
              });

              console.log('recita stringa')
              console.log(dataStringa)
              if (obj.orario){
                console.log(`orario ${obj.orario.slice(11, 16)}`);
                obj.orario = obj.orario.slice(11, 16);
                reciteStr += dataStringa + " " + obj.orario + ","
              } else {
                console.log("manca orario")
                reciteStr += dataStringa + ","
              }
            })
          }
          obj.reciteStringa = reciteStr
          console.log(obj.reciteStringa)
        });

        const datiDaInviare = { stagione:   this.stagioneCorrente, }
        useJwt.post(apiSpettacoloUrl, datiDaInviare).then((d) => {
          // console.log("Elenco Spettacoli");
          // console.log(d.data);
          this.elencoSpettacoliList = d.data;
        });
      });
    } else {
      console.log("Non trovo UserData, prova ancora");
    }

    // Recupero/definisco i valori di default delle entità utilizzate nel componente

    // praticheSIAEDefaultData ( esplicitato nei pulsanti "Nuovo.." della gridA )
    this.praticheSIAEDefaultData = {};

  },

  provide: {
    // per grid
    grid: [GridToolbar, GridSort, GridFilter, GridEdit, ForeignKey],
    // per multiselect
    multiselect: [CheckBoxSelection],
  },
  methods: {
    onStagioneChange: function (e) {
      console.log("Change")
      console.log("Recupero elenco PraticheSIAE dal backend per l'anno selezionato");
      const datiDaInviare = {
        stagione: this.stagioneCorrente,
      };
      useJwt.post(apiPraticheSIAERicercaUrl, datiDaInviare).then((d) => {
        //console.log("PraticheSIAE");
        console.log(d.data);
        this.praticheSIAEFullData = d.data;

        this.praticheSIAEFullData.forEach((obj) => {
          let reciteStr = ""
          if (obj.recite != null) {
            obj.spettacolo = obj.recite[0].spettacoloName
            obj.recite.forEach(function(r, i, array) {
              const dataRecita = new Date(r.data);
              const dataStringa = dataRecita.toLocaleDateString("it-IT", {
                weekday: "long",
                year: "numeric",
                month: "long",
                day: "2-digit",
              });

              const oraStringa = r.orario.slice(11, 16);
              if (i !== array.length - 1) {
                reciteStr += dataStringa + " " + oraStringa + ", "
              } else {
                reciteStr += dataStringa + " " + oraStringa
              }
            })
          }
          obj.reciteStringa = reciteStr
          // console.log(obj.reciteStringa)
        });
      })
    },
    onStagioneNewChange: function (e) {
        // aggiorna elenco spettacoli con gli spettacoli della stagione attuale
        const datiDaInviare = { stagione: this.praticheSIAEActiveData.stagione, }
        useJwt.post(apiSpettacoloUrl, datiDaInviare).then((d) => {
          // console.log("Elenco Spettacoli");
          // console.log(d.data);
          this.elencoSpettacoliList = d.data;
        });
    },
    onSpettacoloChange: function(e) {
      // recupero recite dello spettacolo selezionato
      const spettacolo_selez = this.$refs.spettacolo.ej2Instances.value

      const datiDaInviare = { spettacolo: spettacolo_selez, }
      useJwt.post(apiReciteRicercaSpettacoloSIAEUrl, datiDaInviare).then((res) => {
        this.gestioneRecite(this, res.data)
        this.praticheSIAEFullData = [...this.praticheSIAEFullData] // refresh list
      });
    },
    spettacoloFiltering: function (e) {
      var searchData = this.elencoSpettacoliList;
      var query = new Query();
      //frame the query based on search string with filter type.
      query = (e.text != "") ? query.where("titolo", "contains", e.text, true) : query; // puoi usare contains, startsWith, or endsWith
      //pass the filter data source, filter query to updateData method.
      e.updateData(searchData, query);
    },
    gestioneRecite(context, dati) {
        console.log("Recite");
        console.log(dati);
        context.reciteSpettacoloFullData = dati;
        // fix aggiornamento orario
        context.reciteSpettacoloFullData.forEach((obj) => {
          if (obj.orario != null) {
            console.log(`orario ${obj.orario.slice(11, 16)}`);
            obj.orario = obj.orario.slice(11, 16);
          }
        });
    },
    // per dialogA
    dialogAOpen(args) {
      // evita chiusura dialog su pressione enter
      let dialogObj = args.element.ej2_instances[0];
      dialogObj.keyDown = this.noop.bind(this);
      dialogObj.dataBind();
    },
    dialogAClose() {
      console.log("Chiusura dialogA");
      this.dialogA.tabAdialogAIndex = 0;
      //console.log(this.praticheSIAEActiveData);
    },
    dialogAOk() {
      console.log("Cliccato bottone OK di dialogA");
      // salvataggio informazioni in remoto
      if (this.praticheSIAEActiveId === 0) {
        // salvataggio in caso di new
        const datiDaInviare = {
          pratica: this.praticheSIAEActiveData,
          recite: this.reciteSpettacoloFullData,
        };
        useJwt
          .post(apiPraticheSIAEUrl, datiDaInviare)
          .then((res) => {
            // TODO: gestione errore creazione
            if (res.status == 200 || res.status == 201) {
              console.log("PraticaSIAE CREATA")
              //console.log(res.data)
              // mi segno ID elemento appena creato
              this.praticheSIAEActiveId = res.data.id;
              this.makeToast( "primary", "Successo", "Creazione della pratica SIAE")
            } else {
              this.makeToast( "primary", "ERRORE", "Errore nella creazione della pratica");
            }
            return this; // restituisci contesto per permettere aggiornamento grid
          })
          .then((context) => {
            // capire motivo mancato refresh della grid
            const datiDaInviare = { stagione: this.stagioneCorrente, }
            useJwt.post(apiPraticheSIAERicercaUrl, datiDaInviare).then((res) => {
              context.gestioneRecite(context, res.data)
              this.praticheSIAEFullData = res.data;

              this.praticheSIAEFullData.forEach((obj) => {
                let reciteStr = ""
                if (obj.recite != null) {
                  obj.spettacolo = obj.recite[0].spettacoloName
                  obj.recite.forEach((r) => {
                    const dataRecita = new Date(r.data)
                    const dataStringa = dataRecita.toLocaleDateString("it-IT", {
                      weekday: "long",
                      year: "numeric",
                      month: "long",
                      day: "2-digit",
                    });

                    console.log('recita stringa')
                    console.log(dataStringa)
                    if (obj.orario){
                      console.log(`orario ${obj.orario.slice(11, 16)}`);
                      obj.orario = obj.orario.slice(11, 16);
                      reciteStr += dataStringa + " " + obj.orario + ","
                    } else {
                      console.log("manca orario")
                      reciteStr += dataStringa + ","
                    }
                  })
                }
                obj.reciteStringa = reciteStr
                console.log(obj.reciteStringa)
              });

              console.log( "Aggiornamento gridA con l'aggiunta di una PraticaSIAE")
              context.praticheSIAEFullData = [...context.praticheSIAEFullData] // refresh list
            });
          });
      } else {
        // TODO DA GESTIRE
        // salvataggio in caso di edit
        const editUrl = `${apiPraticheSIAEUrl}/${this.praticheSIAEActiveId}`;
        // qui devo fare caricamento dati ma non include i file da gestire con upload
        useJwt
          .patch(editUrl, this.praticheSIAEActiveData)
          .then((res) => {
            if (res.status == 200 || res.status == 201) {
              this.makeToast(
                "primary",
                "Successo",
                "Modifica della pratica SIAE"
              );
            }
            console.log(res.status);
            return this; // restituisci contesto per permettere aggiornamento gridA
          })
          .then((context) => {
            const datiDaInviare = {
              annoRiferimento: this.annoRiferimentoCorrente,
            };
            useJwt.post(apiPraticheSIAERicercaUrl, datiDaInviare).then((res) => {
              console.log(
                "Aggiornamento gridA con la modifica di una praticaSIAE"
              );
              context.praticheSIAEFullData = res.data;
              context.praticheSIAEFullData = [...context.praticheSIAEFullData];
            });
          });
      }
      this.$refs.dialogA.hide();
      // triggerare aggiornamento filtering / ordinamento? <----------------------
    },
    dialogACancel() {
      console.log("Cliccato bottone Cancel di dialogA");
      this.$refs.dialogA.hide();
    },
    // per gridA
    gridAClickHandler(args) {
      // pulsante NEW
      if (args.item.id === "new") {
        this.dialogA.header = "Nuova Pratica SIAE";
        const oggi = new Date;
        this.praticheSIAEDefaultData = {
          id: 0,
          dataCreazione: oggi,
          recite: null,
          stagione: oggi.getFullYear().toString(),
          stato: "dagenerare",
          filePratica: null,
        };
        // svuota grid secondaria recite
        this.reciteSpettacoloFullData = []
        this.praticheSIAEActiveData = this.praticheSIAEDefaultData;
        console.log("Premuto pulsante creazione nuova praticaSIAE da gridA");

        // console.log(this.praticheSIAEActiveData);
        // console.log(this.praticheSIAEDefaultData);
        this.praticheSIAEActiveId = 0;
        this.$refs.dialogA.show(true);
      }
      // pulsante EDIT
      else if (args.item.id === "edit") {
        console.log("Premuto pulsante modifica praticaSIAE da gridA");
        try {
          const selectedRow = this.$refs.gridA.getSelectedRecords()
          let found = false
          this.praticheSIAEActiveId = selectedRow[0].id
          this.praticheSIAEActiveData = selectedRow[0]


          // spettacolo generico
          console.log("Edit praticaSIAE");
          this.dialogA.header = "Modifica praticaSIAE";
          this.$refs.dialogA.show(true);
        } catch (err) {
          console.log("Occorre selezionare una riga della tabella");
          this.alertAShow();
        }
      }
      // Pulsante DELETE
      else if (args.item.id === "delete") {
        try {
          console.log("Premuto pulsante elimina praticaSIAE da gridA");
          const selectedRow = this.$refs.gridA.getSelectedRecords();
          const deletedElementId = selectedRow[0].id;

          const deleteUrl = `${apiPraticheSIAEUrl}/${deletedElementId}`;

          useJwt.delete(deleteUrl).then((res) => {
            console.log("Eliminazione avvenuta con successo");
            // console.log(res.data)
          });
          this.$refs.gridA.ej2Instances.deleteRecord();
        } catch (err) {
          console.log(err);
          console.log("Occorre selezionare una riga della tabella");
          this.alertAShow();
        }
      } else if (args.item.id === "download") {
          const selectedRow = this.$refs.gridA.getSelectedRecords();
          this.praticheSIAEActiveId = selectedRow[0].id;
          // console.log("gridA, Id selezionato:");
          const i = this.praticheSIAEFullData.findIndex(
            (x) => x.id === this.praticheSIAEActiveId
          );
          if (i >= 0) {
            this.praticheSIAEActiveData = this.praticheSIAEFullData[i];
            console.log("praticaSIAE CORRENTE");
            console.log(this.praticheSIAEActiveData);
            
            const link = document.createElement("a");
            link.href = this.praticheSIAEActiveData['filePratica']
            link.setAttribute("download", "praticaSIAE.docx");
            document.body.appendChild(link);
            link.click();
          }
      }
    },
    gridAactionBegin(e) {
      // Add and edit operations
      if (e.requestType === "save") {
        const editedData = e.data;
        console.log(editedData);
        // The default edit operation is cancelled
        e.cancel = true;
        const editUrl = `${apiPraticheSIAEUrl}/${editedData.id}`;
        useJwt.patch(editUrl, editedData).then((res) => {
          console.log(res);
          if (res.status === 200) {
            // se tutto OK
            // If your data is updated at the server side successfully, we can call the grid endEdit() method to save the edited data to the Grid
            this.$refs.gridA.endEdit();
          } else {
            this.makeToast(
              "primary",
              "Attenzione",
              "Salvataggio praticaSIAE non riuscito"
            );
          }
        });
      }
    },
    // Grid’s actionComplete event handler
    // Triggers after an action is completed
    gridAactionComplete(e) {
    },

    // per alert
    alertACountDownChanged(alertADismissCountDown) {
      this.alertADismissCountDown = alertADismissCountDown;
    },
    alertAShow() {
      this.alertADismissCountDown = this.alertADismissSecs;
    },
    // per toast
    makeToast(variant = null, title = "titolo", message = "messaggio") {
      this.$bvToast.toast(message, {
        title,
        variant,
        solid: true,
        autoHideDelay: 5000,
      });
    },
    noop() {
      console.log("premuto enter");
    },
  },
});

/* eslint-disable global-require */
</script>

<style lang="scss">
@import "~@syncfusion/ej2-base/styles/material.css";
@import "~@syncfusion/ej2-buttons/styles/material.css";
@import "~@syncfusion/ej2-vue-buttons/styles/material.css";
@import "~@syncfusion/ej2-calendars/styles/material.css";
@import "~@syncfusion/ej2-calendars/styles/datepicker/material.css";
@import "~@syncfusion/ej2-dropdowns/styles/material.css";
@import "~@syncfusion/ej2-vue-popups/styles/material.css";
@import "~@syncfusion/ej2-vue-navigations/styles/material.css";
@import "~@syncfusion/ej2-inputs/styles/material.css";
@import "~@syncfusion/ej2-vue-layouts/styles/material.css";
@import "~@syncfusion/ej2-splitbuttons/styles/material.css";
@import "~@syncfusion/ej2-grids/styles/material.css";

.e-btn-icon.e-open-icon {
  background: url("~@/assets/images/svg/open2-svgrepo-com.svg");
  height: 18px;
  width: 18px;
}

.e-btn-icon.e-delete-icon {
  background: url("~@/assets/images/svg/garbage-svgrepo-com.svg");
  height: 18px;
  width: 18px;
}

.e-btn-icon.e-download-icon {
  background: url("~@/assets/images/svg/download2-svgrepo-com.svg");
  height: 18px;
  width: 18px;
}

.e-btn-icon.e-search-icon {
  background: url("~@/assets/images/svg/search-svgrepo-com.svg");
  height: 18px;
  width: 18px;
}

.e-btn-icon.e-upload-icon {
  background: url("~@/assets/images/svg/upload-svgrepo-com.svg");
  height: 18px;
  width: 18px;
}

.e-btn-icon.e-add-icon {
  background: url("~@/assets/images/svg/add2-svgrepo-com.svg");
  height: 18px;
  width: 18px;
}

// seleziono il colore per evidenziare la riga selezionata
.e-grid td.e-active {
  background-color: #e5cbdd;
}
</style>
